import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import type { LikeTabRoute } from '../components/LikeContents';

export const useLogTabNavigation = (routes: LikeTabRoute[]) => {
  const logClickUpperTab = useCallback(
    (prevIndex: number, nextIndex: number) => {
      const prevRoute = routes[prevIndex];
      const nextRoute = routes[nextIndex];
      if (!prevRoute || !nextRoute || prevIndex === nextIndex) return;

      bridge.logAnalyticsEvent({
        name: 'CLICK_UPPER_TAB',
        channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
        analytics: {
          EVENT_TYPE: 'CLICK_UPPER_TAB',
          SCREEN: prevRoute.screen_name,
          LABEL: nextRoute.name,
        },
      });
    },
    [routes],
  );

  return { logClickUpperTab };
};
